import React from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { SinglePathSVG } from "components/views/SVG"
import { Spacer } from "components/views/atoms/Atoms"
import CarrotPropTypes from "../../../../utils/CarrotPropTypes"
import { UserMenu } from "./UserMenu"

const Hamburger = (props) => (
  <button className="f3 dn-ns pv3 ph35 pa0-ns bn bg-transparent black-80" onClick={props.onClick}>
    <div className="hamburger">
      <div className="hamburger-inner" />
    </div>
  </button>
)

Hamburger.propTypes = {
  collapsed: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
}

const Logo = () => (
  <Link to="/" className="f3 ph4 carrot-orange">
    <SinglePathSVG icon="newLogo" />
  </Link>
)

const LogoBar = (props) => (
  <div className="relative w-100 flex justify-center no-underline bg-pampas" style={{ height: 80 }}>
    <div className="w-100 flex flex-column-ns items-center items-start-ns justify-between">
      <Hamburger collapsed={props.collapsed} onClick={props.onClick} />
      <div className="dn db-ns w-100">
        <Spacer height={3.5} />
      </div>
      <Logo />

      <div className="db dn-ns">
        <Spacer width={3.5} />
        <UserMenu />
      </div>
    </div>
  </div>
)

LogoBar.propTypes = {
  fullName: CarrotPropTypes.userInfo.fullName,
  collapsed: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
}

export default LogoBar
